// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-container {
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.notifications-title {
  color: #003366;
  text-align: center;
  margin-bottom: 30px;
  font-size: 28px;
  font-weight: bold;
}

.notifications-paper {
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.no-notifications {
  text-align: center;
  color: #666666;
  margin-top: 20px;
}

.notifications-list-item {
  border-bottom: 1px solid #eeeeee;
}

.notifications-list-item:last-child {
  border-bottom: none;
}

.notifications-list-item-text {
  color: #003366;
}

.notifications-clear-button {
  background-color: #cc0000;
  color: white;
}

.notifications-clear-button:hover {
  background-color: #aa0000;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Notifications/NotificationsPage.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".notifications-container {\n  background-color: white;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.notifications-title {\n  color: #003366;\n  text-align: center;\n  margin-bottom: 30px;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.notifications-paper {\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.no-notifications {\n  text-align: center;\n  color: #666666;\n  margin-top: 20px;\n}\n\n.notifications-list-item {\n  border-bottom: 1px solid #eeeeee;\n}\n\n.notifications-list-item:last-child {\n  border-bottom: none;\n}\n\n.notifications-list-item-text {\n  color: #003366;\n}\n\n.notifications-clear-button {\n  background-color: #cc0000;\n  color: white;\n}\n\n.notifications-clear-button:hover {\n  background-color: #aa0000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
